import { reactive } from 'vue'

export const store = reactive({
  language: 'english',

  // UI State
  showStartPage: true,
  showSliderPage: false,
  
  selectedImage: 0,
})
